import {Component} from "@angular/core";
import {SizeGroupSearchModel} from "../size-group-search.model";
import {SizeGroupEntityModel} from "../size-group-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-size-group-search-page",
    templateUrl: "./size-group-search-page.component.html",
    providers: [provideSearchModel(SizeGroupSearchModel), provideEntityModel(SizeGroupEntityModel)]
})
export class SizeGroupSearchPageComponent extends AbstractSearchPage {
}
